const API_CONFIG = {
   // BASE_URL: 'https://api.test.g2inovartech.com.br',
    BASE_URL: 'https://api.g2pecas.com.br',

    ENDPOINTS: {
        LOGIN: '/api/login',

        // Endpoints de Prefeituras
        PREFEITURAS: {
            LISTAR: '/api/prefeituras',
            CADASTRAR: '/api/prefeituras',
            ATUALIZAR: (id) => `/api/prefeituras/${id}`,
            DETALHES: (id) => `/api/prefeituras/${id}`
        },

        // Endpoints de Solicitações
        SOLICITACOES: {
            LISTAR: '/api/solicitacoes',
            CADASTRAR: '/api/solicitacoes',
            ATUALIZAR: (id) => `/api/solicitacoes/${id}`,
            PREFEITURA: (id) => `/api/solicitacoesPrefeitura/${id}`,
            FORNECEDOR: (id) => `/api/solicitacoesFornecedor/${id}`,
            ENVIAR: '/api/enviarSolicitacao',
            ITENS: (id) => `/api/itensSolicitacao/${id}`,
            ITENS_FORNECEDOR: (id) => `/api/itensSolicitacaoFornecedor/${id}`,
            ATUALIZAR_ITEM: (id) => `/api/itens/${id}`,
            ITENS_FALTANTES: (id) => `/api/solicitacoes/${id}/itens-nao-cotados`
        },

        // Endpoints de Compras
        COMPRAS: {
            LISTAR_TODAS_COMPRAS: '/api/compras',
            LISTAR_HISTORICO_COMPRAS_PRE: '/api/historico-compras',
            LISTAR_HISTORICO_COMPRAS_FORNECEDOR: '/api/historico-fornecedor',
            CADASTRAR_COMPRA: '/api/compras',
            APROVAR_COMPRA: '/api/compras/aprovar',
            ENVIAR_NOTA_FISCAL: (id) => `/api/compras/${id}/nota`,
            DOWNLOAD_NOTA_FISCAL: (id) => `/api/compras/${id}/nota/download`,
            VER_ITENS_COMPRA: (id) => `/api/itensCompra/${id}`,
            REVISAR_COMPRA: (id) => `/api/revisarCompra/${id}`,
        },
        // Endpoints de Cotação
        COTACOES: {
            LISTAR: '/api/cotacoes',
            CADASTRAR: '/api/cotacoes',
            LISTAR_ESPECIFICA: (id) => `/api/cotacoes/${id}`,
            LISTAR_COTACAO_ENVIADAS_FOR: (id) => `/api/cotacoesFornecedor/${id}`,
            LISTAR_COTACAO_FORNECEDORES: (id) => `/api/cotacoesSolicitacao/${id}`,
            ITENS_COTACAO: (id) => `/api/itensCotacao/${id}`,
        },

        // Endpoints de Veiculos
        VEICULOS: {
            LISTAR_TODOS: '/api/veiculos', // Lista todos os veiculos
            CADASTRAR: '/api/veiculos', // Cadastra um veiculo
            VEICULO_PREFEITURA: (id) => `/api/veiculosPrefeitura/${id}`, // Lista os veiculos de uma prefeitura
            VEICULO_ESPECIFICO: (id) => `/api/veiculos/${id}`, // Lista um veiculo especifico
            ATUALIZAR: (id) => `/api/veiculos/${id}`, // Atualiza um veiculo
           
        },

        // Endpoints de Usuarios
        USUARIOS: {
            CONSULTAR_USUARIO: (id) => `/api/usuarios/${id}`,
            CADASTRAR: '/api/usuarios',
            DELETAR_USUARIO: (id) => `/api/users/${id}`,
            ATUALIZAR_USUARIO: (id) => `/api/usuarios/${id}`,
            CONSULTAR_TODOS: '/api/usuarios',
        },

        // Endpoints de Prefeitura
        PREFEITURA: {
            CONSULTAR_PREFEITURA: '/api/prefeituras',
            CONSULTAR_PREFEITURA_ESPECIFICO: (id) => `/api/prefeituras/${id}`,
            ATUALIZAR_PREFEITURA: (id) => `/api/prefeituras/${id}`,
            CADASTRAR: '/api/prefeituras',
            ORGAOS_DA_PREFEITURAS: (id) => `/api/orgaosPrefeitura/${id}`,


        },

        //Endpoints de Contrato
        CONTRATO: {
            CONSULTAR_CONTRATO: '/api/contratos',
            CONSULTAR_CONTRATO_ESPECIFICO: (id) => `/api/contratos/${id}`,
            CADASTRAR_CONTRATO: '/api/contratos',
            ATUALIZAR_CONTRATO: (id) => `/api/contratos/${id}`,
        },

        //Endpoints de Fornecedores
        FORNECEDOR: {
            CONSULTAR_FOR: '/api/fornecedores',
            CONSULTAR_FOR_ESPECIFICO: (ID) => `/api/fornecedores/${ID}`,
            ATUALIZAR_FOR: (id) => `/api/fornecedores/${id}`,
            CADASTRAR: '/api/fornecedores',

        },

        //Endpoints de ORGÃO
        ORGAO: {
            CADASTRAR_ORGAO: '/api/orgaos',
            CONSULTAR_ORGAO: (id) => `/api/orgaos/${id}`,
            CONSULTAR_TODOS: '/api/orgaos',
            ATUALIZAR_ORGAO: (id) => `/api/orgaos/${id}`,
            DELETAR_ORGAO: (id) => `/api/orgaos/${id}`,
            ORGAO_PREFEITURA: (id) => `/api/orgaosPrefeitura/${id}`,
        },

        // Endpoints de Relatórios
        RELATORIOS: {
            GERAL_ADM: '/api/relatorio/compras/aprovadas',
            COMPRAS_ADM: '/api/relatorio/compras',
            COMPRAS_PRE: '/api/relatorio/compras/prefeitura',
            VENDAS_FOR: '/api/relatorio/vendas/fornecedor',
        }
    }
};

export default API_CONFIG; 